import React from 'react';
import { IconArrowsLeft, IconArrowsRight } from '@carnica/graphics';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Navigation = function Navigation(_ref) {
  var prevSlide = _ref.prevSlide,
    nextSlide = _ref.nextSlide;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('navigation'),
    "data-t-id": "components-Navigation"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "\u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0441\u043B\u0430\u0439\u0434",
    className: cx('navigation-btn'),
    onClick: prevSlide,
    type: "button"
  }, /*#__PURE__*/React.createElement(IconArrowsLeft, {
    className: cx('navigation-icon'),
    size: 15
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": "\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0441\u043B\u0430\u0439\u0434",
    className: cx('navigation-btn'),
    onClick: nextSlide,
    type: "button"
  }, /*#__PURE__*/React.createElement(IconArrowsRight, {
    className: cx('navigation-icon'),
    size: 15
  })));
};